/** Format helpers for the event window (UTC-stable, matches eventWindow.ts). */

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const pad = (n: number) => String(n).padStart(2, '0')

/** e.g. "Thu Apr 8, 14:30" */
export function formatDateTime(epochMs: number): string {
  const d = new Date(epochMs)
  return `${DOW[d.getUTCDay()]} ${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}, ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`
}

/** e.g. "Apr 8 14:30" (compact) */
export function formatShort(epochMs: number): string {
  const d = new Date(epochMs)
  return `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`
}
